/**
 * Breadcrumbs — pasek nawigacji powrotu do katalogu.
 * Wyświetla się pod banerem i nad główną treścią strony publicznej
 * (firma / hodowla), żeby klient nie utknął w profilu.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Breadcrumbs({ items = [], theme = 'dark' }) {
  const filtered = items.filter(i => i && (i.label || '').trim());
  if (filtered.length === 0) return null;

  const isDark = theme !== 'light';
  const bg = isDark ? 'rgba(10, 14, 25, 0.92)' : 'rgba(248, 250, 252, 0.95)';
  const border = isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)';
  const txt = isDark ? '#94a3b8' : '#64748b';
  const txtHi = isDark ? '#e2e8f0' : '#0f172a';
  const accent = '#10b981';

  return (
    <nav
      data-testid="breadcrumbs"
      aria-label="Nawigacja"
      style={{
        position: 'relative',
        zIndex: 55,
        background: bg,
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${border}`,
        padding: '10px 24px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          flexWrap: 'wrap',
          fontSize: '13px',
          color: txt,
        }}
      >
        <Link
          to={items[0]?.href || '/'}
          data-testid="breadcrumb-back"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            color: accent,
            textDecoration: 'none',
            fontWeight: 500,
            marginRight: '6px',
          }}
          onMouseEnter={e => (e.currentTarget.style.textDecoration = 'underline')}
          onMouseLeave={e => (e.currentTarget.style.textDecoration = 'none')}
        >
          <ChevronLeft style={{ width: '14px', height: '14px' }} />
          Wróć
        </Link>
        {filtered.map((item, idx) => {
          const isLast = idx === filtered.length - 1;
          return (
            <React.Fragment key={`${item.label}-${idx}`}>
              <ChevronRight style={{ width: '12px', height: '12px', opacity: 0.4 }} />
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  style={{ color: txt, textDecoration: 'none', transition: 'color 0.2s' }}
                  onMouseEnter={e => (e.currentTarget.style.color = txtHi)}
                  onMouseLeave={e => (e.currentTarget.style.color = txt)}
                >
                  {item.label}
                </Link>
              ) : (
                <span style={{ color: isLast ? txtHi : txt, fontWeight: isLast ? 600 : 400, maxWidth: '280px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {item.label}
                </span>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
}
